export const SET_NOTIFICATION = "SET_NOTIFICATION"

export const setNotification = (payload) => dispatch =>
    dispatch({
        type: SET_NOTIFICATION,
        payload: payload
    });